var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.co_getImg_r,"alt":_vm.co_att_s,"loading":"lazy","onerror":("this.onerror=null;this.src='" + _vm.pb_defaultImg_r + "'")}})}
var staticRenderFns = []

export { render, staticRenderFns }